import {
    apiRequest,
    daftarpegawai,
    PromotionPegawaiCreate,
    daftarpangkat,
    PromotionPegawaiDetail,
    PromotionPegawaiApprove,
    berkasGet,
    berkasUpload
} from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", PromotionPegawaiApprove, {
            body: query
        }, true)
    }
    fetchEmployee = async (query) => {
        return await apiRequest("get", daftarpegawai, {
            params: query
        }, true)
    }
    fetchRank = async (query) => {
        return await apiRequest("get", daftarpangkat, {
            params: query
        }, true)
    }
    fetchDetail = async (query) => {
        return await apiRequest("get", PromotionPegawaiDetail, {
            params: query
        }, true)
    }

    fetchBerkasGet = async (query) => {
        return await apiRequest("get", berkasGet, {
            params: query
        }, true)
    }

    fetchBerkasUpload = async (query) => {
        return await apiRequest("post", berkasUpload, {
            body: query
        }, true)
    }
}

export default CreateRepository